module.exports = __webpack_public_path__ + "img/personal_top@2x.489b9c79.png";